import { render, staticRenderFns } from "./AssistantAsksRegion.vue?vue&type=template&id=2ddae7b3&"
import script from "./AssistantAsksRegion.vue?vue&type=script&lang=js&"
export * from "./AssistantAsksRegion.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports